import { type JSX } from 'react';
import makeMatcher from 'wouter/matcher';
// @ts-ignore
import Icon from '@svgr-iconkit/themify-icons';

const defaultMatcher = makeMatcher();

export function isActive(path: string) {
    const [match] = defaultMatcher(path, window.location.pathname);
    return match;
}

export function isParentActive(paths: string[]) {
    return paths.some((path) => {
        const [match] = defaultMatcher(path, window.location.pathname);
        return match;
    });
}

export function getIcon(icon: JSX.Element | string) {
    return typeof icon === 'string' ? (
        <Icon
            name={icon}
            size={25}
        ></Icon>
    ) : (
        icon
    );
}
